import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiClock, FiShield, FiCheckCircle, FiStar } = FiIcons;
const { FaWhatsapp } = FaIcons;

const Hero = () => {
  return (
    <section id="home" className="relative min-h-[90vh] flex items-center pt-32 pb-16">
      <div className="absolute inset-0">
        <img 
          src="https://i.postimg.cc/65GDyMVL/Hero.jpg"
          alt="Expert local drainage services in Manchester"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-7 text-white"
          >
            <div className="inline-flex items-center space-x-2 bg-blue-600/30 backdrop-blur-sm border border-blue-400/30 px-4 py-2 rounded-full mb-6 text-left">
              <SafeIcon icon={FiStar} className="text-yellow-400" />
              <span className="text-sm font-bold tracking-wide uppercase">Manchester's Local Choice</span>
            </div>
            
            <h1 className="text-4xl lg:text-7xl font-bold mb-6 leading-tight text-left">
              Expert local drainage <br />
              <span className="text-yellow-400">services in Manchester</span>
            </h1>
            
            <p className="text-xl lg:text-2xl mb-8 text-gray-200 max-w-2xl font-medium text-left">
              Expert local drainage services covering Manchester and surrounding areas - family-run since 2009.
            </p>

            <div className="flex flex-wrap gap-4 mb-10">
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-lg">
                <SafeIcon icon={FiCheckCircle} className="text-green-400" />
                <span className="font-semibold">Same Day Service</span>
              </div>
              <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-lg">
                <SafeIcon icon={FiShield} className="text-blue-400" />
                <span className="font-semibold">07459 014304</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="tel:+447459014304"
                className="bg-red-600 text-white px-10 py-5 rounded-xl font-bold text-xl hover:bg-red-700 transition-all shadow-xl flex items-center justify-center space-x-3"
              >
                <SafeIcon icon={FiPhone} />
                <span>Call Local Engineer</span>
              </a>
              <a 
                href="https://wa.me/447459014304"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#25D366] text-white px-10 py-5 rounded-xl font-bold text-xl hover:bg-[#128c7e] transition-all flex items-center justify-center space-x-2"
              >
                <SafeIcon icon={FaWhatsapp} />
                <span>WhatsApp Us</span>
              </a>
            </div>

            <p className="mt-8 text-gray-300 text-lg flex items-center space-x-2 font-medium text-left">
              <SafeIcon icon={FiClock} className="text-yellow-400" />
              <span>Book a local engineer today. Fast response, no surprises.</span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;